import { CheckoutPaymentMethod } from "../PaymentMethod.ts";
import { NormasTeachingProductDTO } from "../../ProductService/NormasTeachingProduct/useNormasTeachingProductById.ts";
import { mapCurrencyToSymbol } from "./mapCurrencyToSymbol.ts";
import { NormasTeachingBundleDTO } from "../../ProductService/NormasTeachingBundle/useNormasTeachingBundleById.ts";
import {
  CouponType,
  NormasTeachingCouponDTO,
} from "../../ProductService/NormasTeachingCoupon/useNormasTeachingCouponById.ts";

export function getPaymentPrice(
  method: CheckoutPaymentMethod,
  product: NormasTeachingProductDTO | NormasTeachingBundleDTO,
  numberOfInstallments?: number,
  coupon?: NormasTeachingCouponDTO,
): string {
  const couponValue =
    coupon?.value.couponType == CouponType.Percentage
      ? (product.priceInCents.amount * coupon.value.amount) / 100
      : (coupon?.value.amount ?? 0);
  const priceWithCoupon = product.priceInCents.amount - couponValue;
  if (method === CheckoutPaymentMethod.StripeOneTime) {
    return `${priceWithCoupon / 100} ${mapCurrencyToSymbol(product.priceInCents.currency)}`;
  } else if (method === CheckoutPaymentMethod.StripeInstallments) {
    if (numberOfInstallments === undefined) return "";
    else {
      const finalPrice = Math.floor(priceWithCoupon / numberOfInstallments);
      return `${(finalPrice / 100).toFixed(2)} ${mapCurrencyToSymbol(product.priceInCents.currency)}/mese`;
    }
  } else return "";
}
